"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ProgressBar = _interopRequireDefault(require("../../atoms/ProgressBar"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "progressBarClass", "total", "now", "setNow", "buttonLeftText", "buttonRightText", "showPercentage", "onLeftButtonClick", "onRightButtonClick", "steps", "disableLeft", "disableRight", "ariaDescribedBy"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".ProgressNavBar .progressNav {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n}\n.ProgressNavBar .progressNav__button {\n  padding: 0;\n  border: none;\n  background: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: #424242;\n  font-size: 1rem;\n}\n.ProgressNavBar .progressNav__button:hover {\n  color: #bebebe;\n}\n.ProgressNavBar .progressNav__button--disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.ProgressNavBar .progressNav__button__arrow {\n  position: relative;\n  z-index: 2;\n}\n.ProgressNavBar .progressNav__button__arrow::after, .ProgressNavBar .progressNav__button__arrow::before {\n  content: \"\";\n  width: 0.75rem;\n  height: 0.0625rem;\n  background-color: #424242;\n  position: absolute;\n  border-radius: 1px;\n}\n.ProgressNavBar .progressNav__button__arrow--left {\n  margin-right: 1.25rem;\n}\n.ProgressNavBar .progressNav__button__arrow--left::before {\n  top: -4px;\n  left: 0;\n  transform: rotate(-45deg);\n}\n.ProgressNavBar .progressNav__button__arrow--left::after {\n  top: 4px;\n  left: 0;\n  transform: rotate(45deg);\n}\n.ProgressNavBar .progressNav__button__arrow--right {\n  margin-left: 1.25rem;\n}\n.ProgressNavBar .progressNav__button__arrow--right::before {\n  top: -4px;\n  right: 0;\n  transform: rotate(45deg);\n}\n.ProgressNavBar .progressNav__button__arrow--right::after {\n  top: 4px;\n  right: 0;\n  transform: rotate(-45deg);\n}\n.ProgressNavBar .progressNav__status {\n  margin: 0;\n  font-weight: 700;\n}";
  var fileName = "ProgressNavBar_ProgressNavBar";
  var element = document.querySelector("style[data-sass-component='ProgressNavBar_ProgressNavBar']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var ProgressNavBar = function ProgressNavBar(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$progressBarClass = _ref.progressBarClass,
    progressBarClass = _ref$progressBarClass === void 0 ? '' : _ref$progressBarClass,
    _ref$total = _ref.total,
    total = _ref$total === void 0 ? 100 : _ref$total,
    _ref$now = _ref.now,
    now = _ref$now === void 0 ? 1 : _ref$now,
    _ref$setNow = _ref.setNow,
    setNow = _ref$setNow === void 0 ? function () {} : _ref$setNow,
    _ref$buttonLeftText = _ref.buttonLeftText,
    buttonLeftText = _ref$buttonLeftText === void 0 ? 'BACK' : _ref$buttonLeftText,
    _ref$buttonRightText = _ref.buttonRightText,
    buttonRightText = _ref$buttonRightText === void 0 ? 'NEXT' : _ref$buttonRightText,
    _ref$showPercentage = _ref.showPercentage,
    showPercentage = _ref$showPercentage === void 0 ? false : _ref$showPercentage,
    _ref$onLeftButtonClic = _ref.onLeftButtonClick,
    onLeftButtonClick = _ref$onLeftButtonClic === void 0 ? function () {} : _ref$onLeftButtonClic,
    _ref$onRightButtonCli = _ref.onRightButtonClick,
    onRightButtonClick = _ref$onRightButtonCli === void 0 ? function () {} : _ref$onRightButtonCli,
    _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? 1 : _ref$steps,
    _ref$disableLeft = _ref.disableLeft,
    disableLeft = _ref$disableLeft === void 0 ? false : _ref$disableLeft,
    _ref$disableRight = _ref.disableRight,
    disableRight = _ref$disableRight === void 0 ? false : _ref$disableRight,
    _ref$ariaDescribedBy = _ref.ariaDescribedBy,
    ariaDescribedBy = _ref$ariaDescribedBy === void 0 ? '' : _ref$ariaDescribedBy,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var onLeftClickButton = function onLeftClickButton() {
    setNow(now - steps >= 0 ? now - steps : 0);

    // This optional parameter (result of this operation) is passed instead of 'now' prop in the callback because being asynchronous, the setter doesn't update the number at the same time.

    onLeftButtonClick(now - steps >= 0 ? now - steps : 0);
  };
  var onRightClickButton = function onRightClickButton() {
    if (buttonRightText !== 'CANCEL') {
      setNow(now + steps <= total ? now + steps : total);
    }
    onRightButtonClick(now + steps <= total ? now + steps : total);
  };
  var percentage = now && total ? Math.round(now / total * 100) : 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    tabIndex: 0,
    "aria-describedby": "ptag ".concat(ariaDescribedBy),
    className: "ProgressNavBar ".concat(className)
  }, rest), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ProgressBar["default"], {
      percentage: percentage,
      className: progressBarClass
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "progressNav",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        className: "progressNav__button ".concat(disableLeft || now === 0 ? 'progressNav__button--disabled' : ''),
        onClick: function onClick() {
          return onLeftClickButton();
        },
        disabled: disableLeft || now === 0,
        "aria-disabled": disableLeft || now === 0,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "progressNav__button__arrow progressNav__button__arrow--left"
        }), buttonLeftText]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        id: "ptag",
        "aria-live": "polite",
        className: "progressNav__status",
        children: showPercentage ? "".concat(percentage, "%") : "".concat(now, " of ").concat(total)
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        className: "progressNav__button ".concat(disableRight || now === total ? 'progressNav__button--disabled' : ''),
        onClick: function onClick() {
          return onRightClickButton();
        },
        disabled: disableRight || now === total,
        "aria-disabled": disableRight || now === total,
        children: [buttonRightText, buttonRightText !== 'CANCEL' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "progressNav__button__arrow progressNav__button__arrow--right"
        }) : null]
      })]
    })]
  }));
};
var _default = ProgressNavBar;
exports["default"] = _default;